import Axios from "axios";
import helperMethods from "./helpers/helperMethods";

Axios.interceptors.response.use(
  response => {
    // Do something with response data
    return response;
  },
  error => {
    helperMethods.setSnackBarErrorFromErrorResponse(error);
    return Promise.reject(error);
  }
);

Axios.interceptors.request.use(
  response => {
    // Do something with response data
    // console.log(response.headers);
    return response;
  },
  error => {
    helperMethods.setSnackBarErrorFromErrorResponse(error);
    return Promise.reject(error);
  }
);
